import React from 'react';
import Core from '../../lib/Core';
import Box from '../Layout/Wrappers/Box';
import Button from '../Layout/Wrappers/Button';
import TextField from '../Layout/Wrappers/TextField';
import Typography from '../Layout/Wrappers/Typography';
import {
  censorEmail
} from '../../lib/String.lib';
import {
  Fun
} from '../../lib/Function.lib';

export default function TwoFactorInput({
  email = '',
  onSubmit = Fun,
  ...props
}) {
  const [code, setCode] = React.useState(new Array(6).fill(''));
  const inputsRef = React.useRef([]);

  const handleChange = (event, index) => {
    const val = event.target.value.replace(/[^0-9]/g, '');
    if (!val) return;

    const newCode = [...code];
    newCode[index] = val[0];
    setCode(newCode);

    if (index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !code[index] && index > 0) {
      const newCode = [...code];
      newCode[index - 1] = '';
      setCode(newCode);
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = event.clipboardData.getData('text').slice(0, 6).replace(/[^0-9]/g, '');
    if (!paste) return;

    const pasteArr = paste.split('');
    const newCode = [...code];
    for (let index = 0; index < 6; index++) {
      newCode[index] = pasteArr[index] || '';
    }
    setCode(newCode);
    const lastIndex = Math.min(pasteArr.length, 6) - 1;
    inputsRef.current[lastIndex]?.focus();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const fullCode = code.join('');
    if (fullCode.length === 6) {
      onSubmit(fullCode);
    }
    else {
      Core.showWarning('Please enter the full 6-digit code');
    }
  };

  return (
    <Box column component="form" onSubmit={handleSubmit}>
      <Typography
        className="c-black-dark mb-2 center"
      >
        A code has been sent to your email ({censorEmail(email)})
        <br />
        Please enter your code
      </Typography>
      <Box row>
        {code.map((digit, index) => (
          <TextField
            key={index}
            inputRef={(self) => (inputsRef.current[index] = self)}
            value={digit}
            onChange={(event) => handleChange(event, index)}
            onKeyDown={(event) => handleKeyDown(event, index)}
            onPaste={handlePaste}
            inputProps={{
              maxLength: 1,
              inputMode: 'numeric',
              style: {
                textAlign: 'center',
                fontSize: '1.5rem',
                width: '3rem',
              },
            }}
            placeholder='   '
            className='mx-05'

          />
        ))}
      </Box>
      <Box className='mt-3'>
        <Button type="submit" fullWidth>
          Verify Code
        </Button>
      </Box>
    </Box>
  );
}
